import React from 'react';
import { Mountain, CheckCircle2, Download, Hash, Calendar, Building2 } from 'lucide-react';
export function MembershipCard() {
  return <div className="bg-white rounded-2xl p-6 h-full flex flex-col" style={{
    boxShadow: '0 4px 24px rgba(0,0,0,0.07)'
  }} data-id="element-168">
      {/* Header */}
      <div className="flex items-center justify-between mb-5" data-id="element-169">
        <div className="flex items-center gap-3" data-id="element-170">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{
          backgroundColor: '#eff8ff'
        }} data-id="element-171">
            <Mountain className="w-5 h-5" style={{
            color: '#3b8fd4'
          }} data-id="element-172" />
          </div>
          <div data-id="element-173">
            <h3 className="font-semibold text-slate-800 text-base" data-id="element-174">
              Моє членство
            </h3>
            <p className="text-xs text-slate-400" data-id="element-175">
              Федерація Альпінізму України
            </p>
          </div>
        </div>
        {/* Status badge */}
        <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold" style={{
        backgroundColor: '#eff8ff',
        color: '#2b7fc4'
      }} data-id="element-176">
          <CheckCircle2 className="w-3.5 h-3.5" data-id="element-177" />
          Активний
        </div>
      </div>

      {/* Fields */}
      <div className="flex flex-col gap-3 flex-1" data-id="element-178">
        <InfoRow icon={<Hash className="w-4 h-4" style={{
        color: '#3b8fd4'
      }} data-id="element-180" />} label="Номер члена" value="UAF-2024-0847" valueClass="font-mono font-semibold text-slate-700" data-id="element-179" />
        <InfoRow icon={<Building2 className="w-4 h-4" style={{
        color: '#3b8fd4'
      }} data-id="element-182" />} label="Місцевий осередок" value='СК "Вертикаль" (Харків), Харківська область' data-id="element-181" />
        <InfoRow icon={<Calendar className="w-4 h-4" style={{
        color: '#3b8fd4'
      }} data-id="element-184" />} label="Дата вступу" value="15 березня 2021" data-id="element-183" />
        <InfoRow icon={<Calendar className="w-4 h-4" style={{
        color: '#94a3b8'
      }} data-id="element-186" />} label="Термін дії" value="31 грудня 2025" data-id="element-185" />
      </div>

      {/* Divider */}
      <div className="border-t border-slate-50 mt-5 pt-4" data-id="element-187">
        <button className="flex items-center gap-2 text-sm font-medium transition-colors hover:opacity-80" style={{
        color: '#3b8fd4'
      }} data-id="element-188">
          <Download className="w-4 h-4" data-id="element-189" />
          Завантажити посвідчення
        </button>
      </div>
    </div>;
}
interface InfoRowProps {
  icon: React.ReactNode;
  label: string;
  value: string;
  valueClass?: string;
}
function InfoRow({
  icon,
  label,
  value,
  valueClass
}: InfoRowProps) {
  return <div className="flex items-center gap-3 p-3 rounded-xl" style={{
    backgroundColor: '#f8fafc'
  }} data-id="element-190">
      <div className="flex-shrink-0" data-id="element-191">{icon}</div>
      <div className="flex-1 min-w-0" data-id="element-192">
        <p className="text-xs text-slate-400 mb-0.5" data-id="element-193">{label}</p>
        <p className={`text-sm text-slate-700 truncate ${valueClass || 'font-medium'}`} data-id="element-194">
          {value}
        </p>
      </div>
    </div>;
}